module.exports = __webpack_public_path__ + "img/brand.e5633575.jpg";